import { GoogleClassroomClient } from "@/services/GoogleClassroom";
import { GoogleOAuthClient } from "@/services/GoogleOAuth";
import { FirestoreClient } from "@/services/FirestoreClient";
import {
  ClassroomAttachmentEntity,
  CreateAnnouncementAttachmentArgs,
} from "@/types/services";

export class OakAttachment {
  constructor(
    private readonly baseUrl: string,
    private readonly firestoreClient: FirestoreClient,
  ) {}

  /**
   * Creates a Google Classroom attachment and persists it to Firestore.
   * @param args - The attachment including course, item, and lesson details
   * @param oauthClient - An authenticated OAuth client for the user
   */
  public async createAttachment(
    args: CreateAnnouncementAttachmentArgs,
    oauthClient: GoogleOAuthClient,
  ): Promise<ClassroomAttachmentEntity | null> {
    const classroomClient = new GoogleClassroomClient(
      this.baseUrl,
      oauthClient,
    );

    const classroomAttachment =
      await classroomClient.createAnnouncementAttachment(args);
    const data = {
      ...classroomAttachment,
      attachmentId: classroomAttachment.id,
      createdAt: new Date().toISOString(),
      ...(args.teacherLoginHint
        ? { teacherLoginHint: args.teacherLoginHint }
        : {}),
    };

    await this.firestoreClient.upsertClassroomAttachment(data);
    const savedAttachment =
      await this.firestoreClient.getClassroomAttachmentById(
        classroomAttachment.id,
      );

    return savedAttachment;
  }
}
